import { createStore, applyMiddleware, compose } from 'redux';
import logger from 'redux-logger';
import { persistStore, persistReducer } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';
import createSagaMiddleware from 'redux-saga';
import rootReducer from 'redux/rootReducer';
import rootSaga from 'redux/rootSaga';

const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: autoMergeLevel2,
  whitelist: ['authReducer', 'feedbackReducer'],
};

const config = () => {
  // Create the saga middleware
  const sagaMiddleware = createSagaMiddleware();
  //
  const persistedReducer = persistReducer(persistConfig, rootReducer);
  // Enhancer setting for Redux Devtools, ONLY in development env.
  const composeEnhancers =
    process.env.REACT_APP_VERCEL_ENV !== 'production' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          // Specify extension’s options like name, actionsDenylist, actionsCreators, serialize...
          // redux devtool에서 action trace기능 필요할때 사용, 성능에 영향을 끼치기 때문에 필요할때만 주석해제
          // trace: true,
        })
      : compose;
  const enhancer = composeEnhancers(applyMiddleware(sagaMiddleware));
  // Mount it on the Store
  const store = createStore(persistedReducer, enhancer);
  // then run the sagas
  sagaMiddleware.run(rootSaga);

  //
  const persistor = persistStore(store);
  return { store, persistor };
};

export default config;
